module.exports = __webpack_public_path__ + "img/practical-go-lessons-book8.efeca77b.jpg";